import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxLabel, CheckboxSquare, Dash, HiddenCheck, LabelContainer } from './CheckboxStyledComponents';
import { IconCheck } from '../Icons';
import { white, steel } from '../../styles/colors';

var Checkbox = function Checkbox(_ref) {
  var as = _ref.as,
      checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      htmlAttributes = _ref.htmlAttributes,
      inputHtmlAttributes = _ref.inputHtmlAttributes,
      name = _ref.name,
      onChange = _ref.onChange,
      someSelected = _ref.someSelected,
      style = _ref.style,
      value = _ref.value;

  var renderIcon = function renderIcon() {
    if (disabled && !checked) {
      return React.createElement(Dash, {
        "data-testid": "icon-checkbox-blank-readonly",
        disabled: true
      });
    }

    if (checked && someSelected) {
      return React.createElement(Dash, {
        "data-testid": "icon-checkbox-someselected"
      });
    }

    if (checked && !someSelected) {
      return React.createElement(IconCheck, {
        "data-testid": "icon-checkbox-checked".concat(disabled ? '-readonly' : ''),
        size: "medium",
        color: disabled ? steel : white
      });
    }

    return null;
  };

  return React.createElement(CheckboxLabel, _extends({
    as: as,
    className: className,
    style: style,
    disabled: disabled
  }, htmlAttributes), React.createElement(HiddenCheck, _extends({
    checked: checked,
    disabled: disabled,
    name: name,
    onChange: onChange,
    value: value
  }, inputHtmlAttributes)), React.createElement(CheckboxSquare, null, renderIcon()), children !== null && React.createElement(LabelContainer, null, children));
};

Checkbox.propTypes = {
  as: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  htmlAttributes: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  inputHtmlAttributes: PropTypes.object,
  name: PropTypes.string,
  someSelected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  value: PropTypes.string
};
Checkbox.defaultProps = {
  as: undefined,
  children: null,
  className: '',
  disabled: false,
  htmlAttributes: {},
  inputHtmlAttributes: {},
  name: '',
  someSelected: false,
  style: {},
  value: ''
};
export default Checkbox;